import { render, staticRenderFns } from "./bulkExpenditures.vue?vue&type=template&id=ae4096dc&"
import script from "./bulkExpenditures.vue?vue&type=script&lang=js&"
export * from "./bulkExpenditures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports